import gql from 'graphql-tag';

export const GET_GARBAGE_STATISTICS = gql`
    query GetGarbageStatistics($email: String!) {
        garbageStatistics(email: $email) {
            id
            date
            weight
        }
    }
`;
